<template>
  <v-app>
    <v-content>
      <container-slot>
        <v-col>
          <h1 class="text-center display-1 font-weight-medium">
            404 Not Found
          </h1>
        </v-col>
      </container-slot>
    </v-content>
  </v-app>
</template>

<script>
import ContainerSlot from "@/components/ContainerSlot";
export default {
  components: {
    ContainerSlot,
  },
  name: "NotFound",
  title() {
    return "Not Found Page";
  },
};
</script>

<style></style>
